import "leaflet-rotatedmarker";
import { Icon } from "leaflet";
import stationaryMarker from "../../../assets/stationary-marker.png";
import fastMarker from "../../../assets/moving-marker-fast.png";
import slowMarker from "../../../assets/moving-marker-slow.png";
import unauthStop from "../../../assets/unauthorized-stop.png";
import { Marker, Popup, Tooltip } from "react-leaflet";
import "../../../css/MissionControll.css";
import { forwardRef, memo, useEffect, useRef, useState } from "react";
import { missionControlActions } from "../../../store/mission-control/mission-control-slice";
import { useDispatch, useSelector } from "react-redux";
import { getJobInfo } from "../../../api/finance/addChargesApi";

const MovingMarker = memo(
  forwardRef(
    ({ lat, lng, rotation, speed, children, terminalId, vehicleNo }, ref) => {
      const markerRef = useRef(null);
      const dispatch = useDispatch();
      const [isUnauthorizedStop, setIsUnAuthorizedStop] = useState(false);
      const jobData = useSelector(
        (state) => state.missionControl.jobInfo[terminalId],
      );
      const [isPopupOpen, setIsPopupOpen] = useState(false);
      const popupRef = useRef(null);

      useEffect(() => {
        if (isPopupOpen) {
          markerRef.current?.openPopup();
        } else {
          markerRef.current?.closePopup();
        }
      }, [isPopupOpen]);

      useEffect(() => {
        if (speed === 0) {
          setTimeout(async () => {
            const jobDetails = await getJobInfo(jobData.jobId);
            if (
              jobDetails[0].statusId === 8 ||
              jobDetails[0].statusId === 14 ||
              jobDetails[0].statusId === 20
            ) {
              setIsUnAuthorizedStop(true);
            }
          }, 60000);
        }
      }, [jobData.jobId, lat, lng, speed]);

      useEffect(() => {
        dispatch(
          missionControlActions.setSpeed({
            terminalId: terminalId,
            speed: speed,
          }),
        );
      }, [dispatch, speed, terminalId]);

      useEffect(() => {
        const marker = markerRef.current;
        if (marker) {
          marker.setRotationAngle(rotation);
          marker.setRotationOrigin("center");
        }
      }, [rotation]);

      const icon = new Icon({
        iconUrl:
          speed === 0
            ? isUnauthorizedStop
              ? unauthStop
              : stationaryMarker
            : speed > 40
              ? fastMarker
              : slowMarker,
        iconSize: [24, 24],
        iconAnchor: [12, 12],
        className: speed === 0 && isUnauthorizedStop ? "blinking" : "",
      });

      return (
        <Marker
          ref={(el) => {
            markerRef.current = el;
            if (ref) {
              ref.current = el;
            }
          }}
          icon={icon}
          position={[lat, lng]}
        >
          <Popup
            ref={(pr) => (popupRef.current = pr)}
            className="request-popup"
            onClick={() => {
              setIsPopupOpen((prevState) => !prevState);
            }}
          >
            {children}
          </Popup>
          {!isPopupOpen && (
            <Tooltip direction="top" offset={[0, -10]} opacity={1} permanent>
              <span>{vehicleNo}</span>
            </Tooltip>
          )}
        </Marker>
      );
    },
  ),
);

export default MovingMarker;
